import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Overline } from "./Reveal";
import welcomeImg from "@/assets/welcome.png";

export const WelcomeBanner = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [28, -28]);

  return (
    <section
      ref={ref}
      id="welcome"
      data-testid="welcome-section"
      className="py-20 md:py-32 bg-surface/40 border-y border-line/40"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <Overline>A warm welcome awaits</Overline>
          <p className="font-serif italic text-textMuted text-xl md:text-2xl mt-6 max-w-xl mx-auto">
            The greeting every guest is met with, before making their way down to the cellar.
          </p>
        </Reveal>
        <Reveal delay={0.12} className="mt-10">
          <motion.div
            style={{ y }}
            className="relative rounded-sm overflow-hidden border border-line/60 shadow-[0_40px_100px_-30px_rgba(0,0,0,0.75)]"
          >
            <img
              src={welcomeImg}
              alt="Welcome to The Old Pub Cellar — your private retreat awaits, please make your way down the stairs"
              className="w-full h-auto"
              data-testid="welcome-image"
            />
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
};
